export default __webpack_public_path__ + "static/media/av.0ce81a0a.jpg";